import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getEventList = (eventData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_EVENT_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/event/list`,
        eventData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_EVENT_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_EVENT_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_EVENT_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addEvent = (eventPayload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_EVENT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/event/add`,
        eventPayload,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_EVENT_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_EVENT_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to add event");
      dispatch({
        type: "ADD_EVENT_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const editEvent = (eventPayload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_EVENT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/event/update`,
        eventPayload,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_EVENT_SUCCESS", payload: data });
        toast.success("Edited Successfully!");
        return data;
      } else {
        dispatch({ type: "EDIT_EVENT_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to add event");
      dispatch({
        type: "EDIT_EVENT_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewEvent = (eventPayload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_EVENT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/event/view/${eventPayload}`,

        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_EVENT_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "VIEW_EVENT_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "VIEW_EVENT_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
